export default __webpack_public_path__ + "static/reck-n-1f8b51751c733af203514c19b7c6ab75.webp";